import React, { useState } from "react";
import ButtonVector from '../../../assets/buttonVector.svg';
import FrequentlyAskQuestion from './FrequentlyAskQuestion';
import ImageSection from './ImageSection';
import {motion} from 'framer-motion'
import axios from 'axios';
import { useEffect } from "react";
import {Link, useNavigate } from "react-router-dom";

const Frequently = () => {
  const [faqData, setFaqData] = useState([]);
  const getFAQData = () => {
    axios.get(`${process.env.REACT_APP_BASE_URL}/faqs`)
    .then(response => {
      setFaqData(response.data)
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    });
  }
  useEffect(() => {
    getFAQData();
  }, [])
  
  return (
    <div className="relative bg-gradient-to-br from-gray-50 to-blue-50 py-16 lg:py-20 overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 left-10 w-32 h-32 bg-blue-100/50 rounded-full blur-3xl"></div>
        <div className="absolute top-40 right-20 w-24 h-24 bg-orange-100/50 rounded-full blur-2xl"></div>
        <div className="absolute bottom-20 left-1/4 w-40 h-40 bg-purple-100/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-32 right-1/3 w-28 h-28 bg-pink-100/40 rounded-full blur-2xl"></div>
      </div>
      
      {/* Geometric Patterns */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <svg className="absolute top-20 right-10 w-16 h-16 text-blue-200" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
        <svg className="absolute bottom-40 left-16 w-12 h-12 text-orange-200" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
        </svg>
        <svg className="absolute top-1/2 right-6 w-8 h-8 text-purple-200" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      </div>
      
      <div className="relative z-10">
        <div className="w-full lg:w-[90%] xl:w-[85%] mx-auto px-4 lg:px-6">
          {/* Header Section */}
          <div className="text-center mb-12 lg:mb-16">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="flex flex-col lg:flex-row lg:justify-between items-center lg:items-end gap-6 lg:gap-0"
            >
              <div className="text-center lg:text-left">
                <h1 className="font-extrabold text-3xl sm:text-4xl lg:text-5xl xl:text-6xl leading-tight text-[#14183E] mb-4">
                  Frequently Asked Questions
                </h1>
                <p className="text-lg lg:text-xl text-[#5E6282] max-w-2xl">
                  Find answers to common questions about our training programs and services
                </p>
              </div>
              <motion.div
                whileHover={{ scale: 1.05 }}
                className="shrink-0"
              >
                <Link 
                  to={`/faq`} 
                  className="inline-flex items-center gap-2 bg-gradient-to-r from-[#B02526] to-[#d63031] text-white px-6 py-3 rounded-full font-semibold text-sm lg:text-base hover:shadow-lg transition-all duration-300 transform hover:scale-105"
                >
                  See All FAQ 
                  <img className="w-4 h-4" src={ButtonVector} alt="Arrow" />
                </Link>
              </motion.div>
            </motion.div>
          </div>
          
          {/* Content Section */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16 items-start">
            {/* FAQ Section - Increased width */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="order-2 lg:order-1 lg:col-span-2"
            >
              <div className="bg-white/70 backdrop-blur-sm rounded-3xl p-6 lg:p-8 shadow-lg border border-white/20">
                <FrequentlyAskQuestion faqData={faqData} />
              </div>
            </motion.div>
            
            {/* Image Section - Centered and simplified */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="order-1 lg:order-2 lg:col-span-1 flex justify-center items-center"
            >
              <motion.div 
                className="relative w-full max-w-md"
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.3 }}
              >
                <div className="relative bg-white/80 backdrop-blur-sm rounded-3xl p-6 shadow-2xl overflow-hidden flex items-center justify-center">
                  <motion.div
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.6 }}
                    className="w-full"
                  >
                    <ImageSection />
                  </motion.div>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Frequently;
